import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { api, mediaUrl } from "@/lib/api";
import { Plus } from "lucide-react";

const TOTAL_SLOTS = 50;

const normalizeUrl = (url) => {
  if (!url) return "#";
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

export default function Sponsor() {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/sponsors")
      .then((res) => setSponsors(res.data))
      .finally(() => setLoading(false));
  }, []);

  const placeholderCount = Math.max(0, TOTAL_SLOTS - sponsors.length);
  const placeholders = Array.from({ length: placeholderCount });

  return (
    <div className="relative z-10">
      <Header />

      <section className="max-w-6xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-6">
        <p className="label-ui text-[#9F583F] mb-5 fade-up">Spazi pubblicitari</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight text-[#1C1917] max-w-3xl fade-up">
          Le aziende che <span className="italic text-[#9F583F]">sostengono</span> Il Cassetto delle Giraffe.
        </h1>
        <p className="font-body text-lg text-[#57534E] mt-8 max-w-2xl leading-relaxed fade-up">
          Vuoi far conoscere la tua attività ai lettori del blog? Il tuo logo può trovare
          posto in uno dei 50 spazi qui sotto. Clicca su uno spazio libero per richiedere informazioni.
        </p>
        <div className="flex items-center gap-3 mt-6 label-ui text-[#57534E]">
          <span>{sponsors.length}/{TOTAL_SLOTS} spazi occupati</span>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 md:px-10 pb-10" data-testid="sponsor-grid">
        {loading ? (
          <p className="font-ui text-sm text-[#57534E] py-16">Caricamento…</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 border-t border-[#E7E5E4] pt-12">
            {sponsors.map((s) => (
              <a
                key={s.id}
                href={normalizeUrl(s.url)}
                target="_blank"
                rel="noopener noreferrer sponsored"
                data-testid={`sponsor-${s.id}`}
                title={s.name}
                className="group relative aspect-square border border-[#E7E5E4] bg-white flex items-center justify-center p-4 overflow-hidden transition-colors hover:border-[#9F583F]"
              >
                {s.logo ? (
                  <img
                    src={mediaUrl(s.logo)}
                    alt={s.name}
                    className="max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <span className="font-display text-xl text-[#1C1917] text-center leading-tight group-hover:text-[#9F583F] transition-colors">
                    {s.name}
                  </span>
                )}
                <span className="absolute bottom-0 left-0 right-0 bg-[#1C1917] text-white label-ui py-2 text-center translate-y-full group-hover:translate-y-0 transition-transform">
                  Visita il sito
                </span>
              </a>
            ))}

            {placeholders.map((_, i) => (
              <Link
                key={`ph-${i}`}
                to="/contatti?tipo=sponsor"
                data-testid={`sponsor-placeholder-${i}`}
                className="group aspect-square border border-dashed border-[#D6D3D1] flex flex-col items-center justify-center gap-2 text-[#A8A29E] hover:border-[#9F583F] hover:text-[#9F583F] hover:bg-[#F2F0EB] transition-colors"
              >
                <Plus size={22} strokeWidth={1.5} className="transition-transform duration-300 group-hover:rotate-90" />
                <span className="label-ui text-center px-2 text-[0.6rem]">Il tuo logo qui</span>
              </Link>
            ))}
          </div>
        )}

        <div className="mt-14 border-t border-[#E7E5E4] pt-10">
          <p className="font-body text-[#57534E]">
            Interessato a uno spazio?{" "}
            <Link to="/contatti?tipo=sponsor" className="text-[#9F583F] link-underline" data-testid="sponsor-contact-link">
              Scrivimi
            </Link>{" "}
            e ne parliamo.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
